import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import PageNavBar from "@components/PageNavBar"
import SiteLogo from "@images/logo.png"
import styles from "./PageHeader.module.scss"
import "./PageHeader.module.scss"

const PageHeader = ({ siteTitle }) => (
  <header
    style={{
      background: `rebeccapurple`,
      marginBottom: `1.45rem`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
      }}
      className={ "w-100 " + styles.headerParent }
    >
      <div className={styles.headerLogoSection}>
        <h1 style={{ margin: 0 }}>
          <Link
            to="/"
            style={{
              color: `white`,
              textDecoration: `none`,
            }}
          >
            <img alt={"HyperSocio"} className={ styles.headerLogo } src={SiteLogo} />
          </Link>
        </h1>
      </div>
      <div className={styles.headerMenuSection}>
        <PageNavBar />
      </div>
    </div>
  </header>
)

PageHeader.propTypes = {
  siteTitle: PropTypes.string,
}

PageHeader.defaultProps = {
  siteTitle: ``,
}

export default PageHeader
